// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

// import styles
import styles from './ClickToTweet.module.css';

// define component
const ClickToTweet: React.FunctionComponent<{ text: string; url: string }> = ({ text, url }) => {
  // init hooks
  const { t } = useTranslation('components');

  // render
  return (
    <div className={styles['container']}>
      {text}{' '}
      <a
        className={styles['link']}
        href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}%0A%0A${url}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {t('ClickToTweet.link.label')}
      </a>
    </div>
  );
};

ClickToTweet.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default ClickToTweet;
